<template>
  <router-view></router-view>
</template>

<script>
import './Projects/store';
import './PledgeSetting/store';
export default {
  name: 'Cornucopia'
};
</script>

<style lang="less" scoped></style>
